import React from "react";
import { FaUsers, FaHandshake, FaLightbulb, FaCalendarAlt, FaTrophy } from "react-icons/fa"; 
import "./WhyAboutUs.css";

const WhyAboutUs = () => {
  return (
    <div className="why-about-us">
      <div className="vision-section" id="vision">
        <div className="container">
          <div className="vision-content" data-aos="fade-up">
            <h2 className="bold-white-title">Unsere Mission</h2>
            <p className="vision-text">
              Unser Verein steht für Gemeinschaft, Engagement und persönliche Entwicklung. 
              Wir schaffen eine Umgebung, in der jeder seine Leidenschaft entfalten kann.
            </p>
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="features-section " style={{ backgroundColor: "#f8f9fa" }}>
        <div className="container">
        <h2 className="section-title">Warum unser Verein?</h2>
        <div className="row text-center">
          {[
            { title: "Vielfalt", text: "Unser Verein bietet Aktivitäten für jedes Alter und viele Interessen.", icon: <FaUsers /> },
            { title: "Gemeinschaft", text: "Zusammenhalt und gegenseitige Unterstützung stehen bei uns im Vordergrund.", icon: <FaHandshake /> },
            { title: "Engagement", text: "Unsere Mitglieder gestalten den Verein aktiv mit und prägen unsere Werte.", icon: <FaLightbulb /> },
          ].map((feature, index) => (
            <div className="col-md-4" key={index}>
              <div className="whycard">
              <div className="card feature-card">
                <div className="feature-icon">{feature.icon}</div>
                <div className="card-body">
                  <h5 className="card-title">{feature.title}</h5>
                  <p className="card-text">{feature.text}</p>
             
                </div>
              </div>
            </div></div>
          ))}    
        </div></div>
      </div>

      {/* Events Section */}
      <div className="events-section container my-5">
        <h2 className="section-title">Kommende Veranstaltungen</h2>
        <div className="row text-center">
          {[
            { title: "Himmelsfahrtwanderung", text: "Entspannte Wanderung anlässlich Christi Himmelfahrt", date: "29. Mai 2025", icon: <FaCalendarAlt /> },
            { title: "Oktoberfest", text: "Der Verein veranstaltet ein Oktoberfest mit traditionellem Bier und herzhaftem Essen.", date: "25. Oktober 2025", icon: <FaTrophy /> },
          ].map((event, index) => (
            <div className="col-md-6 mb-4" key={index}>
              <div className="card event-card">
                <div className="event-icon">{event.icon}</div>
                <div className="card-body">
                  <h5 className="card-title">{event.title}</h5>
                  <p className="card-text">{event.text}</p>
                  <p className="text-muted">{event.date}</p>
                </div>

              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Join Us Section */}
   
    </ div>
  );
};

export default WhyAboutUs;
